import apiClient from '../../Services/ApiClient';
import { useState } from 'react';
import NoEscape from '../NoEscape';
import Loading from '../Loading';
import { useEffectAsync } from '../../helpers';

export default function PatientPsychoResult({ userId }) {
	const [psychoQuestionnaire, setPsychoQuestionnaire] = useState(false);
	const [psychoQuestionnaireTheme, setPsychoQuestionnaireTheme] =
		useState(null);

	// @ts-ignore
	useEffectAsync(async () => {
		const { data: result } = await apiClient.get(
			'/user/' + userId + '/questionnaire/psycho/result/last/',
		);
		setPsychoQuestionnaireTheme(
			result?.theme === 'green' ? 'text-rohlik' : null,
		);
		setPsychoQuestionnaire(result);
	});

	if (psychoQuestionnaire === false) {
		return (
			<div className={'py-2'}>
				<Loading />
			</div>
		);
	}

	return (
		<>
			{psychoQuestionnaire && (
				<div className='patient-profile__panel__content__patient-data__item'>
					<div
						className={
							'patient-profile__panel__content__patient-data__item__warning-message ' +
							psychoQuestionnaireTheme
						}
					>
						{psychoQuestionnaireTheme !== 'text-rohlik' && (
							<img
								src='/dist/icons/v2/circle-exclamation-solid.svg'
								className='mr-1'
								alt='examination'
							/>
						)}
						{psychoQuestionnaire?.title || ''} —{' '}
						<NoEscape children={psychoQuestionnaire?.description || ''} />
					</div>
				</div>
			)}
		</>
	);
}
